module.exports = __webpack_public_path__ + "img/gummy-reading-room.b4cf4ef0.png";